function safePage(category, name, data) {
  if (typeof analytics !== 'undefined') {
    // eslint-disable-next-line
    return analytics.page(category, name, data);
  }
  return null;
}
export default function page(category, name, data) {
  return safePage(category, name, data);
}